import { UNDERSTANDINGSECTION_HIDE_ERROR, UNDERSTANDING_SECTION, UNDERSTANDING_SECTION_ERROR, UNDERSTANDING_SECTION_START_LOADER, UNDERSTANDING_SECTION_STOP_LOADER, UNDERSTANDING_SECTION_DISPLAY_DATA, } from "../interface/iUnderstandSection";
const initState = {
    data: [],
    displayData: [],
    UnderstandingSectionLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const UnderstandingSectionReducer = (state = initState, action) => {
    switch (action.type) {
        case UNDERSTANDING_SECTION:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case UNDERSTANDING_SECTION_DISPLAY_DATA:
            return Object.assign(Object.assign({}, state), { displayData: action.payload.data });
        case UNDERSTANDING_SECTION_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case UNDERSTANDINGSECTION_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case UNDERSTANDING_SECTION_START_LOADER:
            return Object.assign(Object.assign({}, state), { UnderstandingSectionLoader: true });
        case UNDERSTANDING_SECTION_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { UnderstandingSectionLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default UnderstandingSectionReducer;
